import Service from '@/service'

const logged = {
    homepage: {},
    feeds_banner: {},
    hot_banner: {},
    you_like: {},
    hot_list: {},
    forthcoming_sale_list: {},
    latest_opening_top_banner: {},
    zone_top_in_whole_list: {},
    surplus_list: {},
    find_building: {},
    thematic: {},
    hot_business_list: {},
    hot_business_top_banner: {},
    search_page_banner: {},
    homepage_surplus: {},
    brand_search: {},
    building_detail_top_banner: {},
    hot_search_keyword: {}
}
const Position = {
    refresh (key) {
        logged[key] = {}
    },
    log (key, { id, pos, pos_name }) {
        let position = logged[key] ? logged[key][pos_name] : null
        if (!position) {
            position = []
        }
        if (!position[pos] && position[pos] !== null) {
            position[pos] = id
            logged[key][pos_name] = position
            Service.interestingEvent({
                interesting_id: id,
                event: 'view',
                pos,
                pos_name
            })
        }
    }
}

export default Position

export const clickHouseLog = (id, option) => {
    Service.interestingEvent({
        interesting_id: id,
        event: 'click',
        ...option
    })
}
